import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import { DashboardActions } from 'src/components/organisms/dashboard/DashboardActions';
import { DashboardTasks } from 'src/components/organisms/dashboard/DashboardTasks';
import { DashboardUsage } from 'src/components/organisms/dashboard/DashboardUsage';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import {
  FirstDocumentGuidePanel,
  FirstDocumentGuideReopen,
} from 'src/components/organisms/dashboard/FirstDocumentGuide';
import { FirstDocumentGuideProvider } from 'src/components/hooks/useFirstDocumentGuide';

const sectionTitle = (title: string) => (
  <Typography
    fontSize={{ xs: 22, md: 24 }}
    fontWeight={700}
    letterSpacing="-0.02em"
  >
    {title}
  </Typography>
);

const Dashboard: FC = () => {
  const { t } = useTranslation();

  return (
    <FirstDocumentGuideProvider>
      <Box>
        <FirstDocumentGuidePanel />
        <Grid2 container justifyContent="space-between" spacing={3} sx={{ mb: 4 }}>
          <Grid2 xs={12} md={7.2}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              gap={1}
              sx={{ mb: 1.5, minHeight: 32 }}
            >
              {sectionTitle(t('quickAccess'))}
              <FirstDocumentGuideReopen />
            </Stack>
            <DashboardActions />
          </Grid2>
          <Grid2 xs={12} md={4.5}>
            <Box sx={{ mb: 1.5 }}>{sectionTitle(t('usage'))}</Box>
            <DashboardUsage />
          </Grid2>
        </Grid2>
        <Box>
          <Box sx={{ mb: 1.5 }}>{sectionTitle(t('lastModified'))}</Box>
          <DashboardTasks />
        </Box>
      </Box>
    </FirstDocumentGuideProvider>
  );
};

export default Dashboard;
